import PropTypes from 'prop-types';

import StaticSplitWidthHeroBanner from '../StaticSplitWidth';

import { StyledContainer, StyledImage, OfferBanner } from './styles';

const OfferBannerHero = ({ data, className = '' }) => {
  if (!data) return null;
  const { elements } = data;

  const heroData = elements.find(
    el => el.component === 'static-split-width-content',
  );
  const offerBannerData = elements.find(el => el.component === 'gallery');

  return (
    <StyledContainer>
      {offerBannerData && (
        <OfferBanner
          data-testid="offer-banner"
          backgroundColor={offerBannerData.backgroundColor}
        >
          <StyledImage src={offerBannerData.imagesDam[0]} alt="" />
        </OfferBanner>
      )}
      {heroData && (
        <StaticSplitWidthHeroBanner data={heroData} className={className} />
      )}
    </StyledContainer>
  );
};

OfferBannerHero.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default OfferBannerHero;
